var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "right-base-item", on: { click: _vm.showDetail } },
    [
      _c("div", { staticClass: "flex item-center" }, [
        _c(
          "div",
          { staticClass: "card-icon" },
          [
            _c("svg-icon", {
              attrs: {
                "icon-name": _vm.iconName,
                size: "24",
                iconColor: "#1e49e2",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "item-name" }, [_vm._v(_vm._s(_vm.itemName))]),
      ]),
      _c(
        "div",
        { staticClass: "arrow-right-container border-normal" },
        [
          _c("svg-icon", {
            attrs: {
              "icon-name": "arrow-right",
              size: "18",
              iconColor: "#1e49e2",
            },
          }),
        ],
        1
      ),
      _vm.isShow
        ? _c("ContactSpeedInfo", {
            attrs: {
              type: _vm.type,
              contactList: _vm.contactList,
              KPcontactList: _vm.KPcontactList,
            },
            on: { close: _vm.close },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }